import { useQuery } from "@tanstack/react-query";
import {
  USAGE_HEATMAP_WEEKS,
  usageHeatmapRepository,
} from "../repositories/usageHeatmapRepository";

export const usageHeatmapQueryKey = ["usage", "heatmap", USAGE_HEATMAP_WEEKS] as const;

export const useUsageHeatmapQuery = (enabled = true) =>
  useQuery({
    queryKey: usageHeatmapQueryKey,
    queryFn: () => usageHeatmapRepository.getUsageHeatmap(USAGE_HEATMAP_WEEKS),
    enabled,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 60,
    retry: 2,
  });
